PJQ.collections.rfi = {};

PJQ.models.rfi = {};

PJQ.views.rfi = {};

PJQ.modules.rfi = {
	routes: [
		{
			route: 'projects/:projectId/rfi',
			name: 'rfiList',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "rfi");
			}
		},
		{
			route: 'projects/:projectId/rfi/:rfiId',
			name: 'rfiItem',
			callback: function (projectId, rfiId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "rfi", {
					rfiId: parseInt(rfiId)
				});
			}
		}
	]
};

PJQ.app.addRoutes(PJQ.modules.rfi.routes);